if (typeof self !== "undefined" && typeof self.__figmaWebpackPublicPathOverride === "string") {
  __webpack_require__.p = self.__figmaWebpackPublicPathOverride;
} else if (typeof document !== "undefined" && document?.currentScript?.src) {
  __webpack_require__.p = document.currentScript.src.replace(/\/[^\/]+$/, "/");
}